import { API_ENDPOINT_NAME } from './scoresTableActions.js';
import { getNamespacedFetchActionTypes, } from '../../jsCore/application/sagas/fetchSaga';
import { memoizeFirstCall } from '../../jsCore/utils/fn';

const INITIAL_STATE = {
  IS_INITIALIZED: false,
};

function setState(state, newState){
  return { ...state, ...newState };
}

function setActiveTable(state, newState){
  return { ...state, ...newState };
}

export function scoresTableReducer(state = INITIAL_STATE, action){
  const { SCORES_TABLE_FETCH_ACTION_TYPES } = memoizeFirstCall('SCORES_TABLE_FETCH_ACTION_TYPES', getNamespacedFetchActionTypes, API_ENDPOINT_NAME);
  if (SCORES_TABLE_FETCH_ACTION_TYPES) {
    switch (action.type) {
      case SCORES_TABLE_FETCH_ACTION_TYPES.FETCH.SUCCESS:
        return setActiveTable(state, action.state);
      case SCORES_TABLE_FETCH_ACTION_TYPES.FETCH.FAILED:
        return setState(state, action.state);
      default:
        return state;
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true });
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/scores_table/scoresTableReducer.js